import { State } from "@progress/kendo-data-query";

export default function HasGroups(dataState: State): boolean {
  const { group } = dataState;
  if (!group) {
    return false;
  }

  return group.length > 0;
}
